import { render, staticRenderFns } from "./approvalAgent.vue?vue&type=template&id=85e680b2&scoped=true"
import script from "./approvalAgent.vue?vue&type=script&lang=js"
export * from "./approvalAgent.vue?vue&type=script&lang=js"
import style0 from "./approvalAgent.vue?vue&type=style&index=0&id=85e680b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e680b2",
  null
  
)

export default component.exports